import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {InteractiveListItemPublicProps} from '../../../../../../libs/shared/ui/src/components/interactiveList/interactiveListItem';
import {isDarkTheme} from '../../../../../../libs/shared/ui/src/theme/themeTypeHelpers';
import {UserTheme} from '../../../../../../libs/shared/ui/src/theme/themeTypes';
import {searchTokenBaseStyles} from '../../../../common/searchBar/searchBar';

/*
 * Props.
 */

interface SearchSuggestionsSearchTokenProps extends InteractiveListItemPublicProps {
  value: ReactNode;
  placeholder?: ReactNode;
  shouldHighlight?: boolean;
}

/*
 * Style.
 */

const StyledSearchTokenSpan = styled.span<{$shouldHighlight: boolean}>`
  ${searchTokenBaseStyles}
  background-color: ${(p) => backgroundColor(p.$shouldHighlight, p.theme)};
`;

function backgroundColor(shouldHighlight: boolean, theme: UserTheme) {
  if (isDarkTheme(theme)) {
    return shouldHighlight ? theme.alphas.black20 : theme.alphas.black10;
  }

  return shouldHighlight ? theme.alphas.black40 : theme.alphas.black30;
}

const StyledSearchTokenPlaceholderSpan = styled.span`
  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const SearchSuggestionsSearchToken: FC<SearchSuggestionsSearchTokenProps> = (props) => {
  const {value, placeholder, shouldHighlight, ...otherProps} = props;

  return (
    <StyledSearchTokenSpan $shouldHighlight={Boolean(shouldHighlight)} {...otherProps}>
      {value}
      {placeholder && <StyledSearchTokenPlaceholderSpan>{placeholder}</StyledSearchTokenPlaceholderSpan>}
    </StyledSearchTokenSpan>
  );
};
